<template>
    <div class="flex items-start flex-col">
        <div class="flex flex-row gap-0 -mb-0.5">
            <span class="px-2 paragraph-2xs text-secondary collection:text-secondary-inverse">{{ label }}</span>
        </div>

        <div class="flex flex-row gap-0 cursor-pointer group" @click="handleClick">
            <div
                class="inline-flex pl-2  pr-1 items-center rounded-1 text-secondary paragraph-sm collection:text-secondary-inverse"
            >
                {{ translate('general.select') }}
            </div>

            <button
                class="inline-flex items-center justify-center p-1 rounded-1 group-hover:bg-primary-ghost collection:group-hover:bg-primary-ghost-inverse transition-colors cursor-pointer duration-75"
            >
                <Icon name="chevron-down" :size="20" class="text-primary collection:text-primary-inverse" />
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import Icon from '@/vue/components/design-system/icon/Icon.vue'
import { useTranslationsStore } from '@/vue/stores/translationsStore'

const { translate } = useTranslationsStore()

type Props = {
    count: number
    label: string
}

defineProps<Props>()

const emit = defineEmits<{
    click: []
}>()

function handleClick() {
    emit('click')
}
</script>
